import { isTruthyString } from './utils';

export const STATIC_PATH = '/node_modules/@sitesee/scene-viewer/static';
export const TEST_API_URL = process.env.BIM_API_URL;

export const ENABLE_HYPERBIM = isTruthyString(process.env.SITESEE_ENABLE_HYPERBIM ?? '');
